<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="ServiceChannel Work Orders to Push"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Push work order completions to ServiceChannel."
      @on-submit="createServiceChannelWorkOrdersPushImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="ServiceChannel Work Orders to Push Template.xlsx"
              :file-provider="$importsAPI.getServiceChannelWorkOrdersPushTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ServiceChannelWorkOrdersPushImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'service-channel-work-orders-push-imports-add-modal',
    };
  },
  methods: {
    createServiceChannelWorkOrdersPushImport(data, handleCreate) {
      handleCreate(this.$importsAPI.serviceChannelWorkOrdersPushCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
